import { Navigate, Outlet } from 'react-router';
import { useAppSelector } from '../../store/hooks';
import {
  selectIsGlobalAdmin,
  selectGlobalAdminLoaded
} from '../../store/permissions/permissionsSlice';
import ROUTES from '../../routes/routeConstants';

export function AccountAdminRouteGuard() {
  const isGlobalAdmin = useAppSelector(selectIsGlobalAdmin);
  const globalAdminLoaded = useAppSelector(selectGlobalAdminLoaded);

  if (!globalAdminLoaded) return null;

  if (!isGlobalAdmin) {
    return <Navigate to={`/${ROUTES.locations}`} replace />;
  }

  return <Outlet />;
}
